import React from "react";

import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";
import { MegaCrabBanner } from "../megacrab-banner";
import { GameParams } from "supercell-frontend-base/src/validation/game-params";

import styles from "./styles.modules.scss";

type CommunityData = {
    articles: InboxArticle[];
};

type TabChildProps = {
    locale: LocaleSettings;
    data: GameData;
    userSettings: GameParams;
};

type CommunityViewProps = {
    filterArticles: (articles: InboxArticle[]) => InboxArticle[];
    isMegaCrabPage: boolean;
};

export const CommunityView = ({
    filterArticles,
    isMegaCrabPage,
}: CommunityViewProps) => (
    <Tab namespace="community">
        {(props: TabChildProps) => {
            const data = props.data as CommunityData;
            return (
                <div className={`community ${styles.community}`}>
                    {isMegaCrabPage && <MegaCrabBanner />}

                    <Grid>
                        <div className={`articles ${styles.articles}`}>
                            <List
                                Item={ListArticle}
                                items={
                                    filterArticles(
                                        data.articles,
                                    ) as unknown as InboxArticle[][]
                                }
                                columns={2}
                                perPage={4}
                                footer={null}
                            />
                        </div>
                    </Grid>
                </div>
            );
        }}
    </Tab>
);
